// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"9f426acb","140":"0c03c764","453":"03346f77","490":"e0ab7dae","833":"b7f3d6cb"}[chunkId] + ".chunk.js";
};